.header {
	height: 56px;
	position: sticky;
	top: 0;
	z-index: 100;
	background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-8));
	border-bottom: 1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
}

.inner {
	height: 56px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.brand {
	display: flex;
	align-items: center;
	text-decoration: none;
	color: light-dark(var(--mantine-color-gray-9), var(--mantine-color-white));
	line-height: 1;
	padding: 8px 12px;
	border-radius: var(--mantine-radius-sm);
	font-size: var(--mantine-font-size-lg);
	font-weight: 700;

	@mixin hover {
		background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
	}
}

.logoImg {
	height: rem(32px);
	width: rem(32px);
	flex-shrink: 0;

	[data-mantine-color-scheme='dark'] & {
		filter: invert(1);
	}
}

.link {
	display: block;
	line-height: 1;
	padding: 8px 12px;
	border-radius: var(--mantine-radius-sm);
	text-decoration: none;
	color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-0));
	font-size: var(--mantine-font-size-sm);
	font-weight: 500;

	@media (max-width: $mantine-breakpoint-xs) {
		border-radius: 0;
		padding: var(--mantine-spacing-md);
	}

	@mixin hover {
		background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
	}

	[data-mantine-color-scheme] &[data-active] {
		background-color: var(--mantine-color-crimson-filled);
		color: var(--mantine-color-white);
	}
}
